$(document).ready(function () {
  if (window.location.href == "https://www.gpen.com/pages/buyers-guide") {
    window.location.href = "https://www.gpen.com/collections/buyers-guide";
  }
  $(".item-slider").slick({
    prevArrow:
      "<img class='slick-prev' src='https://cdn.shopify.com/s/files/1/0185/1576/files/arrow_1.png?v=1724441022'>",
    nextArrow:
      "<img class='slick-next' src='https://cdn.shopify.com/s/files/1/0185/1576/files/arrow.png?v=1724441022'>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  });
  $(".collab-slider").slick({
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplaySpeed: 5000,
    arrows: false,
  });
  $(".g-life-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });

  var stHeight = $(".item-slider .slick-track").height();
  var realheight = stHeight * 0.75;
  $(".item-slider .slick-slide").css("height", realheight + "px");

  //if ($(window).width() < 767) {
  //var realheight = stHeight * 0.98;
  //$(".item-slider .slick-slide").css("height", realHeight + "px");
  //}
  if ($(window).width() > 767) {
    var boxHeight = $(".faq-product-grid-reference").height();
    $(".registration-box").css("height", boxHeight * 1.1535 + "px");
    $(".registration-box").css("margin", 0);
  }
  if ($(window).width() < 767) {
    var boxHeight = $(".faq-product-grid-reference").height();
    $(".registration-box").css("height", boxHeight * 1.24 + "px");
    $(".registration-box").css("margin", 0);
  }
  //Begin Buying Guide Scripts
  $("#buying-guide-wax").on("click", function () {
    $("#buying-guide-question-1").addClass("buying-guide-hide-me");
    $("#buying-guide-question-2").removeClass("buying-guide-hide-me");
    material_type = "concentrates";
  });

  $("#buying-guide-herb").on("click", function () {
    $("#buying-guide-question-1").addClass("buying-guide-hide-me");
    $("#buying-guide-question-2").removeClass("buying-guide-hide-me");
    material_type = "ground-material";
  });

  $("#buying-guide-precise").on("click", function () {
    $("#buying-guide-question-2").addClass("buying-guide-hide-me");
    $("#buying-guide-question-3").removeClass("buying-guide-hide-me");
    temp_control = "precise";
  });

  $("#buying-guide-preset").on("click", function () {
    $("#buying-guide-question-2").addClass("buying-guide-hide-me");
    $("#buying-guide-question-3").removeClass("buying-guide-hide-me");
    temp_control = "preset";
  });

  $("#buying-guide-budget").on("click", function () {
    $("#buying-guide-question-3").addClass("buying-guide-hide-me");
    //$("#buying-guide-question-4").removeClass("buying-guide-hide-me");
    price_range = "?filter.v.price.lte=80.00";
    buyingGuideLink = $(location).attr("href");
    filteredLink =
      buyingGuideLink +
      "/" +
      material_type +
      "+" +
      temp_control +
      "+" +
      price_range;
    window.location.href = filteredLink;
  });

  $("#buying-guide-midrange").on("click", function () {
    $("#buying-guide-question-3").addClass("buying-guide-hide-me");
    //$("#buying-guide-question-4").removeClass("buying-guide-hide-me");
    buyingGuideLink = $(location).attr("href");
    filteredLink = buyingGuideLink + "/" + material_type + "+" + temp_control;
    window.location.href = filteredLink;
  });

  $("#buying-guide-premium").on("click", function () {
    $("#buying-guide-question-3").addClass("buying-guide-hide-me");
    //$("#buying-guide-question-4").removeClass("buying-guide-hide-me");
    price_range = "null";
    buyingGuideLink = $(location).attr("href");
    filteredLink =
      buyingGuideLink +
      "/" +
      material_type +
      "+" +
      temp_control +
      "+" +
      price_range;
    window.location.href = filteredLink;
  });

  //$("#buying-guide-filter-time").on("click", function () {
  //buyingGuideLink = $(location).attr("href");
  //filteredLink =
  //buyingGuideLink +
  //"/" +
  //material_type +
  //"+" +
  //temp_control +
  //"+" +
  //price_range;
  //window.location.href = filteredLink;
  //});

  $("#buying-guide-reset-time").on("click", function () {
    window.location.href = "/collections/buyers-guide";
  });
  if ($(window).width() > 767) {
    var collabStHeight = $(".t3-collab-container .slick-track").height();
    var collabRealheight = collabStHeight;
    $(".t3-collab-container .slick-slide").css(
      "height",
      collabRealheight + "px"
    );
  }
});
